"use client";

import { useRef } from "react";
import { ArrowUpRight } from "lucide-react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useGSAP } from "@gsap/react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
gsap.registerPlugin(useGSAP, ScrollTrigger);
const engineCards = [{
  number: "01",
  title: "Sistemas de Engenharia",
  description: "Projetos personalizados de pulverização industrial de alta precisão.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1738660/img/engenharia_sistemas.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1738660/img/engenharia_sistemas.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1738660/img/engenharia_sistemas.png-wvc-sizes",
  alt: "Esquema técnico de sistemas de pulverização industrial de alta precisão"
}, {
  number: "02",
  title: "Tecnologia Spraying",
  description: "Representação exclusiva de bicos e componentes Spraying Systems Co.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1738660/img/tecnologia_spraying.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1738660/img/tecnologia_spraying.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1738660/img/tecnologia_spraying.png-wvc-sizes",
  alt: "Bicos de pulverização industrial de alta performance em ambiente fabril"
}, {
  number: "03",
  title: "Suporte Técnico",
  description: "Consultoria especializada e manutenção desde 1993 em Portugal.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1738660/img/suporte_tecnico.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1738660/img/suporte_tecnico.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1738660/img/suporte_tecnico.png-wvc-sizes",
  alt: "Engenheiro a realizar manutenção em sistema de pulverização industrial"
}];
export default function Solutions() {
  const container = useRef<HTMLDivElement>(null);
  useGSAP(() => {
    const mm = gsap.matchMedia();
    mm.add({
      isDesktop: "(min-width: 1024px) and (prefers-reduced-motion: no-preference)",
      isMobile: "(max-width: 1023px) and (prefers-reduced-motion: no-preference)",
      isReduced: "(prefers-reduced-motion: reduce)"
    }, ctx => {
      const {
        isDesktop,
        isReduced
      } = ctx.conditions as {
        isDesktop: boolean;
        isMobile: boolean;
        isReduced: boolean;
      };
      if (isReduced) {
        gsap.set(".engine-reveal", {
          opacity: 1,
          y: 0
        });
        return;
      }
      if (isDesktop) {
        const pinEl = container.current?.querySelector(".engine-pin-col") as HTMLElement | null;
        const sectionEl = container.current?.querySelector(".engine-section-inner") as HTMLElement | null;
        if (pinEl && sectionEl) {
          ScrollTrigger.create({
            trigger: sectionEl,
            start: "top top+=96",
            end: "bottom bottom",
            pin: pinEl,
            pinSpacing: false
          });
        }
      }
      gsap.set(".engine-intro", {
        y: 24
      });
      gsap.to(".engine-intro", {
        opacity: 1,
        y: 0,
        duration: 0.8,
        stagger: 0.1,
        ease: "power3.out",
        scrollTrigger: {
          trigger: container.current,
          start: "top 80%",
          once: true
        }
      });
      const cards = gsap.utils.toArray<HTMLElement>(".engine-card");
      cards.forEach(card => {
        gsap.set(card, {
          y: 20
        });
        gsap.to(card, {
          opacity: 1,
          y: 0,
          duration: 0.7,
          ease: "power3.out",
          scrollTrigger: {
            trigger: card,
            start: "top 85%",
            once: true
          }
        });
      });
    });
    const refresh = () => ScrollTrigger.refresh();
    requestAnimationFrame(refresh);
    if (document.readyState === "complete") refresh();else window.addEventListener("load", refresh, {
      once: true
    });
    document.fonts?.ready.then(refresh);
  }, {
    scope: container
  });
  return <section data-section-id="31244" id="industrysolutionsoverview" data-nav="light" className="bg-background text-foreground py-32 md:py-44 relative overflow-hidden">
      {}
      <div aria-hidden className="pointer-events-none absolute -top-40 -right-40 w-[520px] h-[520px] rounded-lg opacity-40 blur-[120px]" style={{
      background: "hsl(215 90% 45% / 0.1)"
    }} />

      <div ref={container} className="relative mx-auto max-w-[1360px] px-5 md:px-10 lg:px-16">
        <div className="engine-section-inner grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
          {}
          <div className="engine-pin-col lg:col-span-5">
            <div className="flex flex-col">
              <span className="engine-intro engine-reveal font-default text-xs font-medium uppercase" style={{
              opacity: 0,
              letterSpacing: "0.22em",
              color: "hsl(215 90% 45%)"
            }}>
                SOLUÇÕES
              </span>

              <h2 className="engine-intro engine-reveal font-default mt-6 font-normal" style={{
              opacity: 0,
              fontSize: "clamp(2.25rem, 4.6vw, 4.25rem)",
              lineHeight: 1.02,
              letterSpacing: "-0.03em",
              color: "var(--foreground)"
            }}>Madeiras &amp; Cimentos</h2>

              <p className="engine-intro engine-reveal font-default mt-6 max-w-[52ch]" style={{
              opacity: 0,
              fontSize: "clamp(1.0625rem, 1.15vw, 1.25rem)",
              lineHeight: 1.5,
              color: "hsl(215 12% 40%)"
            }}>Engineered Wood &amp; Cements</p>

              <div className="engine-intro engine-reveal mt-10" style={{
              opacity: 0
            }}>
                <Button asChild variant="ghost" className="group h-auto rounded-lg px-0 py-2 font-default text-base font-normal hover:bg-transparent" style={{
                color: "var(--foreground)"
              }}>
                  <Link to="/ProductsPage" className="inline-flex items-center gap-3">
                    <span className="relative">
                      Ver catálogo técnico
                      <span className="absolute left-0 -bottom-0.5 h-px w-0 transition-all duration-300 ease-out group-hover:w-full" style={{
                      backgroundColor: "hsl(215 90% 45%)"
                    }} />
                    </span>
                    <span className="inline-flex h-6 w-6 items-center justify-center rounded-lg border transition-colors duration-300 group-hover:bg-[hsl(215_90%_45%)]" style={{
                    borderColor: "hsl(215 90% 45%)"
                  }}>
                      <ArrowUpRight className="h-3 w-3 transition-colors duration-300 group-hover:text-white" style={{
                      color: "hsl(215 90% 45%)"
                    }} strokeWidth={1.5} />
                    </span>
                  </Link>
                </Button>
              </div>

              {}
              <div aria-hidden className="mt-16 h-px w-24 hidden lg:block" style={{
              backgroundColor: "hsl(210 10% 85%)"
            }} />
            </div>
          </div>

          {}
          <div className="lg:col-span-7 flex flex-col gap-8">
            {engineCards.map((card, i) => <article key={card.number} data-index={i} className="engine-card group relative overflow-hidden rounded-3xl p-8 md:p-10 transition-all duration-300 hover:-translate-y-0.5" style={{
            opacity: 0,
            backgroundColor: "hsl(210 10% 92% / 0.3)",
            border: "1px solid hsl(210 10% 85%)",
            backdropFilter: "blur(24px) saturate(140%)",
            WebkitBackdropFilter: "blur(24px) saturate(140%)"
          }}>
                {}
                <span aria-hidden className="pointer-events-none absolute inset-x-0 top-0 h-px" style={{
              background: "linear-gradient(90deg, transparent 0%, hsl(215 90% 45% / 0.35) 50%, transparent 100%)"
            }} />

                {}
                <span aria-hidden className="pointer-events-none absolute inset-0 rounded-3xl opacity-0 transition-opacity duration-300 group-hover:opacity-100" style={{
              border: "1px solid hsl(215 90% 45% / 0.35)"
            }} />

                <div className="relative flex items-start justify-between gap-6">
                  {}
                  <div className="relative">
                    <div aria-hidden className="absolute inset-0 -m-8 rounded-lg blur-3xl opacity-70 transition-opacity duration-300 group-hover:opacity-100" style={{
                  background: "hsl(215 90% 45% / 0.1)"
                }} />
                    <span className="relative font-default block" style={{
                  fontSize: "5rem",
                  lineHeight: 0.9,
                  fontWeight: 300,
                  letterSpacing: "-0.05em",
                  color: "hsl(215 90% 45%)"
                }}>
                      {card.number}
                    </span>
                  </div>
                </div>

                {}
                <div className="relative mt-8 overflow-hidden rounded-2xl" style={{
              border: "1px solid hsl(210 10% 85%)",
              backgroundColor: "hsl(210 20% 98%)"
            }}>
                  <div aria-hidden className="pointer-events-none absolute inset-0 opacity-80" style={{
                background: "radial-gradient(ellipse at 50% 50%, hsl(215 90% 45% / 0.05) 0%, transparent 60%)"
              }} />
                  <img src={card.image} data-wvc-srcset={card.srcset} data-wvc-sizes={card.sizes} alt={card.alt} loading="lazy" decoding="async" className="relative block h-56 md:h-72 w-full object-cover" />
                </div>

                {}
                <div className="relative mt-8">
                  <h3 className="font-default" style={{
                fontSize: "clamp(1.5rem, 2.2vw, 2rem)",
                fontWeight: 500,
                letterSpacing: "-0.02em",
                lineHeight: 1.12,
                color: "var(--foreground)"
              }}>
                    {card.title}
                  </h3>
                  <p className="font-default mt-3" style={{
                fontSize: "1.0625rem",
                lineHeight: 1.5,
                color: "hsl(215 12% 40%)"
              }}>
                    {card.description}
                  </p>
                </div>
              </article>)}
          </div>
        </div>
      </div>
    </section>;
}